const options = {
  5: "bg-gray-900/5",
  10: "bg-gray-900/10",
  25: "bg-gray-900/25",
  50: "bg-gray-900/50",
  75: "bg-gray-900/75",
  90: "bg-gray-900/90",
  100: "bg-gray-900",
};

const from = {
  5: "from-gray-900/5",
  10: "from-gray-900/10",
  25: "from-gray-900/25",
  50: "from-gray-900/50",
  75: "from-gray-900/75",
  90: "from-gray-900/90",
  100: "from-gray-900",
};

export default function getBackgroundGray900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
